import React from 'react';
// Constants
import {
  CompanyName,
  CompanyPhoneNumber,
  CompanyTagLine,
} from '../../utils/Constants';
// Images
import MainLogoImage from '../../assets/images/logos/ascari-building-contractors-orange-logo-letter-black.png';

function GeneralHeader({ ServiceName, bgImage }) {
  return (
    <header className='grid h-full w-full'>
      <div className='grid'>
        {/* Section one */}
        <section className='relative grid min-h-[70vh] bg-colour1 general_header_shape justify-center h-full w-full'>
          <div
            className={`z-30 absolute max-h-[68vh] grid items-center general_header_shape justify-center h-full w-full bg-center ${bgImage} bg-no-repeat bg-cover`}
          >
            <div className='absolute inset-0 bg-black/30'></div>
          </div>
          <div className='z-20 absolute min-h-[65vh] grid bg-colour5 general_header_shape justify-center h-full w-full'></div>
        </section>

        {/* Section 2 */}
        <section className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          {/* Header article */}
          <article
            className='grid text-colour1 text-center rounded-lg py-2 lg:py-8 px-8 bg-colour6 fade-effect transition-opacity duration-[5000ms]'
            style={{ opacity: 0.7 }}
          >
            <section className='grid h-fit'>
              <div className='grid -mr-4'>
                <img
                  src={MainLogoImage}
                  alt={`${CompanyName} business logo - Colour2 Logo`}
                  className='min-w-10 h-auto cursor-pointer active:scale-95 mx-auto'
                />
              </div>
              <div>
                <h1 className='text-2xl font-semibold leading-6'>
                  {ServiceName}
                </h1>
              </div>
              <div className='grid mt-2 mx-auto'>
                <a
                  href={`tel:${CompanyPhoneNumber}`}
                  className='grid grid-flow-col w-min  justify-center gap-1'
                >
                  <span className='font-medium'>Call:</span>{' '}
                  {CompanyPhoneNumber}
                </a>
              </div>
            </section>
          </article>
        </section>
      </div>
    </header>
  );
}

export default GeneralHeader;
